import casterscanIcon from '@/public/casterscan-icon-transparent.png';

export default function CasterscanIcon() {
  return (
    <img
      src={casterscanIcon.src}
      alt="Casterscan Icon"
      className="size-7"
    />
  );
};